import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingListModule } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-list/fi-onboarding-list.module';
import { FiOnboardingService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding.service';
import { FiOnboardingEditModule } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-edit/fi-onboarding-edit.module';
import { FiOnboardingBuilderHelperService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-builder-helper.service';
import { FiOnboardingAddDialogComponent } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-add-dialog/fi-onboarding-add-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { FiInfoBannerModule } from '@fi-shared/fi-info-banner/fi-info-banner.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiNameDescriptionInputModule } from '@fi-app/shared/name-description-input/name-description-input.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatSelectModule } from '@angular/material/select';
import { FiOnboardingConnectEditModule } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-connect-edit/fi-onboarding-connect-edit.module';
import { FiOnboardingBuilderStoreService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-builder-store.service';
import { FiOnboardingActionsBuilderService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-actions-builder.service';
import { FiOnboardingViewerModule } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-viewer/fi-onboarding-viewer.module';

@NgModule({
    imports: [
        CommonModule,
        FiOnboardingListModule,
        FiOnboardingEditModule,
        MatRadioModule,
        FormsModule,
        FiInfoBannerModule,
        MatDividerModule,
        FiNameDescriptionInputModule,
        FiAppTextSharedModule,
        MatSelectModule,
        FiOnboardingConnectEditModule,
        FiOnboardingViewerModule,
    ],
    declarations: [FiOnboardingAddDialogComponent],
    providers: [
        FiOnboardingService,
        FiOnboardingBuilderHelperService,
        FiOnboardingBuilderStoreService,
        FiOnboardingActionsBuilderService,
    ],
})
export class FiOnboardingBuilderModule {}
